import { Navigate, useParams } from "react-router-dom";
import { Balance } from "../context/Context";

export default function Init() {
  const { setStoreID } = Balance();
  const params = useParams();

  console.log("in init");

  if (params.storeID) {
    setStoreID(params.storeID);
    return <Navigate to={"/enter-balance"} />;
  } else {
    return <Navigate to={"/not-found"} />;
  }
}
